import { IAuthUser } from "@vokab/shared/src/types";
import { apiCallWithLoading } from "./";


export const getUser = () => apiCallWithLoading<IAuthUser>({
	method: 'GET', url: '/user/me'
});